import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from "@mui/material";

export interface StrikeSelectorProps {
    strikes: number[];
    value: number;
    onValueChange: (newValue: number) => void;
    disabled?: boolean;
}

export function StrikeSelector({
    strikes,
    value,
    onValueChange,
    disabled,
}: StrikeSelectorProps) {
    return (
        <FormControl
            variant="standard"
            size="small" sx={{ width: 120 }}
            disabled={disabled}
        >
            <InputLabel id="strike-label">
                <b>Strikes</b> {getSelectControlLabelExtension(strikes)}
            </InputLabel>
            <Select
                labelId="strike-label"
                value={value?.toString() ?? ' '}
                onChange={(eventArg: SelectChangeEvent<string>) => onValueChange(Number(eventArg.target.value))}
                {...(strikes.length === 0
                    ? { disabled: true }
                    : {})}
            >
                {strikes.map((strike) => (
                        <MenuItem
                            key={strike}
                            value={strike.toString()}
                        >
                            {strike}
                        </MenuItem>
                    ))}
            </Select>
        </FormControl>
    );
}

function getSelectControlLabelExtension(strikes: number[]): string | null {
    return strikes.length > 0
        ? `(${strikes.length} available)`
        : null;
}